<template>
  <AppBody :subtitle="$t('customers.title')" :actions="actions">
    <CardModule untitle>
      <ExpansionPanelFilters>
        <v-form
          @submit.prevent="$loja_consumidor.filtroConsumidores()"
          class="search-forms"
        >
          <v-row>
            <v-col cols="12" md="3" sm="4">
              <BaseTextField
                :label="$t('customers.name')"
                :placeholder="$t('customers.insert-name')"
                v-model="$loja_consumidor.filter.nome"
                data-cy="nome"
              ></BaseTextField>
            </v-col>
            <v-col cols="12" md="3" sm="4">
              <BaseTextField
                :label="$t('customers.email')"
                :placeholder="$t('customers.insert-email')"
                v-model="$loja_consumidor.filter.email"
                data-cy="email"
              ></BaseTextField>
            </v-col>
            <v-col cols="12" md="3" sm="4">
              <BaseTextField
                label="CPF"
                :placeholder="$t('customers.insert-cpf')"
                v-model="$loja_consumidor.filter.documento"
                data-cy="cpf"
                v-mask="['###.###.###-##']"
              >
              </BaseTextField>
            </v-col>
            <v-col cols="12" md="3" sm="4">
              <BaseTextField
                :label="$t('customers.passport')"
                :placeholder="$t('customers.insert-passport')"
                v-model="$loja_consumidor.filter.passaporte"
                data-cy="passaporte"
                v-mask="'XXXXXXXX'"
              ></BaseTextField>
            </v-col>
            <v-col cols="12" md="3" sm="4">
              <BaseAutocomplete
                :label="$t('customers.state')"
                :placeholder="$t('customers.select-state')"
                item-text="dsc_lang"
                return-object
                autocomplete="null"
                clearable
                auto-select-first
                :loading="$config.loading_estados"
                :items="$config.estados.result"
                v-model="estado"
                @click:clear="clearFilterFields('estado')"
              >
              </BaseAutocomplete>
            </v-col>
            <v-col cols="12" md="3" sm="4">
              <BaseAutocomplete
                :label="$t('customers.city')"
                :placeholder="$t('customers.select-city')"
                item-text="dsc_lang"
                item-value="dsc_lang"
                clearable
                :loading="$config.loading_cidades"
                :items="$config.cidades.result"
                @click:clear-icon="clearFilterFields('cidade')"
                v-model="$loja_consumidor.filter.cidade"
              >
              </BaseAutocomplete>
            </v-col>
            <v-col cols="12" md="3" sm="4">
              <BaseTextField
                :label="$t('customers.initial-inclusion-date')"
                v-model="$loja_consumidor.filter.dataInicio"
                type="tel"
                data-cy="data-inicial"
                v-mask="['##/##/####']"
                placeholder="dd/mm/aaaa"
                append-icon="mdi-calendar-blank-outline"
              ></BaseTextField>
            </v-col>
            <v-col cols="12" md="3" sm="4">
              <BaseTextField
                :label="$t('customers.final-inclusion-date')"
                v-model="$loja_consumidor.filter.dataFim"
                type="tel"
                data-cy="data-final"
                v-mask="['##/##/####']"
                placeholder="dd/mm/aaaa"
                append-icon="mdi-calendar-blank-outline"
              ></BaseTextField>
            </v-col>
            <v-col cols="12" md="3" sm="4">
              <BaseSelect
                label="Status"
                :placeholder="$t('customers.select-status')"
                :items="status"
                data-cy="status"
                item-text="text"
                item-value="value"
                v-model="$loja_consumidor.filter.status"
                :color="$config.dados.corinputs"
                clearable
                clear-icon="mdi-close-circle-outline"
                @click:clear-icon="clearFilterFields('regional')"
                :item-color="$config.dados.corinputs"
              >
              </BaseSelect>
            </v-col>
            <v-col cols="12" md="3" sm="4">
              <BaseSelect
                :label="$t('customers.type-of-person')"
                :placeholder="$t('customers.select-type-of-person')"
                :items="pessoa"
                data-cy="Tipo de pessoa"
                v-model="$loja_consumidor.filter.tipoPessoa"
                :color="$config.dados.corinputs"
                clearable
                @click:clear-icon="clearFilterFields('tipoPessoa')"
                :item-color="$config.dados.corinputs"
              >
              </BaseSelect>
            </v-col>
            <v-col v-if="isAdmin" cols="12" md="3" sm="4">
              <BaseAutocomplete
                v-if="isAdmin"
                v-model="$loja_consumidor.filter.sequenciador"
                :label="$t('customers.producer')"
                :placeholder="$t('customers.select-producer')"
                :items="storeList"
                item-text="nome_loja"
                item-value="sequenciador"
                clearable
                @click:clear="clearFilterFields('sequenciador')"
              ></BaseAutocomplete>
            </v-col>
            <v-col cols="12" md="3" sm="4">
              <BaseAutocomplete
                v-model="$loja_consumidor.filter.event"
                :label="$t('check-in.event')"
                :placeholder="$t('check-in.select-event')"
                :no-data-text="$t('common.no-results-found')"
                :items="allEvents"
                :loading="eventsLoading"
                item-text="descricao"
                item-value="idproduto"
                clearable
              />
            </v-col>
            <v-col class="d-flex justify-end">
              <BaseButton variant="filter" type="submit">
                {{ $t("customers.filter") }}
              </BaseButton>
            </v-col>
          </v-row>
        </v-form>
      </ExpansionPanelFilters>

      <template>
        <v-switch
          v-model="singleSelect"
          :label="$t('customers.single-selection')"
          class="pl-3"
          :color="$config.dados.corinputs"
        >
        </v-switch>
      </template>
      <v-data-table
        v-model="$loja_consumidor.select_consumidores"
        :no-data-text="$t('customers.no-results-found')"
        :loading-text="$t('customers.loading-info')"
        mobile-breakpoint="0"
        :headers="headers"
        :items="orderedConsumer"
        :single-select="singleSelect"
        :loading="$loja_consumidor.cadastro.loading_consumidores"
        item-key="idconsumidor"
        show-select
        class="table-body"
        :items-per-page="10"
        :footer-props="{
          itemsPerPageOptions: [10, 20, 50],
          itemsPerPageText: $t('customers.customers-per-page'),
        }"
      >
        <template v-slot:loading>
          <v-skeleton-loader type="table-row-divider@10"></v-skeleton-loader>
        </template>
        <template v-slot:item.ins_dthr="{ item }">
          {{ item.ins_dthr | data_pt_br }}
        </template>
        <template v-slot:item.imagem="{ item }">
          <v-avatar size="30" color="base">
            <v-img :src="item.imagem" v-if="item.imagem"></v-img>
            <p v-else>{{ firstLetter(item.nome || item.razao_social) }}</p>
          </v-avatar>
        </template>
        <template v-slot:item.nome="{ item }">
          {{ item.nome ? item.nome : item.razao_social }}
        </template>
        <template v-slot:item.pessoa="{ item }">
          {{ item.tipo_pessoa == "FISICA" ? item.documento : item.cnpj }}
        </template>
        <template v-slot:item.documento="{ item }">
          {{ item.end_pais === "Brasil" ? item.documento : item.passaporte }}
        </template>
        <template v-slot:item.actions="{ item }" class="table-actions">
          <div style="display: flex; justify-content: center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :color="$config.dados.corinputs"
                  height="30"
                  width="30"
                  small
                  dark
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click="goToConsumer('editar', item)"
                  class="mr-2"
                >
                  <v-icon> mdi-pencil-outline </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("customers.edit") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :color="$config.dados.corinputs"
                  height="30"
                  class="mr-2"
                  v-bind="attrs"
                  v-on="on"
                  width="30"
                  small
                  icon
                  :disabled="!item.historico_pedidos"
                  @click="
                    openModal(
                      'modal-body-pedidos-consumidor',
                      'pedidos',
                      item.idconsumidor
                    )
                  "
                >
                  <v-icon> mdi-cart-outline </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("customers.orders") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  data-cy="ativo"
                  v-show="item.status == 'ATIVO'"
                  :color="$config.dados.corinputs"
                  height="30"
                  v-bind="attrs"
                  v-on="on"
                  width="30"
                  small
                  icon
                  dark
                  @click="
                    $loja_consumidor.desabilitarConsumidor(item.idconsumidor)
                  "
                >
                  <v-icon> mdi-account-cancel-outline </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("customers.disable") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-show="item.status == 'INATIVO'"
                  :color="$config.dados.corinputs"
                  height="30"
                  v-bind="attrs"
                  v-on="on"
                  width="30"
                  small
                  icon
                  dark
                  @click="
                    $loja_consumidor.habilitarConsumidor(item.idconsumidor)
                  "
                >
                  <v-icon>mdi-account-check-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("customers.activate") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-show="isAdmin"
                  :color="$config.dados.corinputs"
                  height="30"
                  v-bind="attrs"
                  v-on="on"
                  width="30"
                  small
                  icon
                  dark
                  @click="openUser(item.email)"
                >
                  <v-icon>mdi-account-eye-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("customers.enter") }}</span>
            </v-tooltip>
          </div>
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip
            :color="item.status == 'ATIVO' ? 'green' : 'error'"
            text-color="#fff"
            small
          >
            {{ item.status }}
          </v-chip>
        </template>
      </v-data-table>
    </CardModule>
    <ModalPedidosConsumidor />
    <ModalItensPedidoConsumidor />
    <ModalExportarConsumidor />
  </AppBody>
</template>

<script>
import LojaConsumidorMixins from "@/mixins/Loja-Consumidor.mixins.js";
import _ from "lodash";
import { ENDPOINTS } from "@/services/Endpoints.js";
import { mapGetters, mapActions, mapMutations } from "vuex";
import CardModule from "@/components/cards/CardModule.vue";
import BaseAutocomplete from "@/components/forms/BaseAutocomplete.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseSelect from "@/components/forms/BaseSelect.vue";
import BaseButton from "@/components/forms/BaseButton.vue";
import ExpansionPanelFilters from "@/components/forms/ExpansionPanelFilters.vue";
export default {
  name: "Consumers",
  mixins: [LojaConsumidorMixins],
  metaInfo() {
    const title = this.$t("customers.title");
    return {
      title: `${title} | ElevenTickets`,
      meta: [
        {
          property: "og:title",
          content: `${title} | ElevenTickets`,
        },
      ],
    };
  },
  components: {
    CardModule,
    BaseTextField,
    BaseSelect,
    BaseAutocomplete,
    BaseButton,
    ExpansionPanelFilters,
    ModalPedidosConsumidor: () =>
      import("@/components/lojas/consumidor/modal-pedidos-consumidor.vue"),
    ModalItensPedidoConsumidor: () =>
      import("@/components/lojas/consumidor/modal-itens-pedido-consumidor.vue"),
    ModalExportarConsumidor: () =>
      import("@/components/lojas/consumidor/modal-exportar-consumidor.vue"),
    AppBody: () => import("@/layouts/components/AppBody.vue"),
  },
  data() {
    return {
      ENDPOINTS: ENDPOINTS,
      NomeLoja: "Consumidor",
      activePicker: null,
      activePicker2: null,
      date: null,
      menu: false,
      menu2: false,
      dtInicial: "",
      dtFinal: "",
      placeholderData: "dd/mm/aa",
      loja: "",
      singleSelect: false,
      estado: "",
      cidade: [],
    };
  },
  computed: {
    ...mapGetters([
      "storeSequencial",
      "isAdmin",
      "storeList",
      "allEvents",
      "eventsLoading",
    ]),
    actions() {
      return [
        {
          name: this.$t("customers.new-register"),
          action: () => this.goToConsumer("new", ""),
        },
        {
          name: this.$t("customers.export"),
          action: () => this.openExportModal(),
        },
      ];
    },
    orderedConsumer() {
      return _.orderBy(
        this.$loja_consumidor.consumidores,
        ["status", "ins_dthr"],
        ["asc", "desc"]
      );
    },
  },
  watch: {
    estado(state) {
      const { id, iso_full } = state;

      this.$loja_consumidor.filter.estado = iso_full;

      const filteredId = this.$config.estados.result.find(
        item => item.dsc === state
      );

      this.$config.getCidades(id || filteredId.id);
    },
    "$loja_consumidor.filter.sequenciador": function () {
      if (this.$loja_consumidor.filter.sequenciador) {
        this.fetchEvents({
          producerId: this.$loja_consumidor.filter.sequenciador,
          filtro: [],
        });
      } else {
        this.setEvents([]);
        this.$loja_consumidor.filter.event = "";
      }
    },
  },
  methods: {
    ...mapActions(["setStoreSelector", "fetchEvents"]),
    ...mapMutations(["setEvents"]),
    firstLetter(word) {
      return word.charAt(0).toUpperCase();
    },
    openExportModal() {
      this.$loja_consumidor.dialogExport = true;
    },
    openModal(name, filter, consumidor) {
      if (filter == "pedidos") {
        this.$loja_consumidor.loading_pedidos = true;
        const payload = {};

        if (this.isAdmin) {
          payload.idconsumidor = consumidor;
          payload.lang = "pt";
          payload.status = [
            "RE",
            "TP",
            "AA",
            "AP",
            "PA",
            "PC",
            "CA",
            "EX",
            "ER",
            "EP",
          ];
        } else {
          payload.filtros = [
            {
              campo: "ped.idconsumidor",
              tipo: "string",
              valor: consumidor,
            },
          ];
          payload.loja = this.storeSequencial;
        }
        this.$axios
          .post(
            this.isAdmin
              ? this.ENDPOINTS.LISTAR_PEDIDOS_MARKET
              : this.ENDPOINTS.LISTAR_PEDIDO_USUARIO_LOJA,
            payload
          )
          .then(response => {
            this.$loja_consumidor.pedidos = response.pedidos || response;
            this.$loja_consumidor.dialogOrders = true;
            this.$loja_consumidor.loading_pedidos = false;
          })
          .catch(error => {
            this.$loja_consumidor.loading_pedidos = false;
            this.$loja_consumidor.dialogOrders = true;
            throw new Error(error);
          });
      } else {
        this.$loja_consumidor.dialogOrders = true;
      }
    },
    replaceSpecialChars(str) {
      str = str.replace(/[ÀÁÂÃÄÅ]/, "A");
      str = str.replace(/[àáâãäå]/, "a");
      str = str.replace(/[ÈÉÊË]/, "E");
      str = str.replace(/[Ç]/, "C");
      str = str.replace(/[ç]/, "c");
      // o resto
      return str.replace(/[^a-z0-9]/gi, "");
    },
    search(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.dsc_lang.toString().toLocaleLowerCase().normalize("NFD")
      );

      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
    openModalSelect() {
      this.$loja_consumidor.cadastro.loading = true;
      this.$loja_consumidor.consumidores = [];
      this.$loja_consumidor.lojas_loading = true;
      this.$loja_consumidor.loja_selecionada = "";
      this.$loja_consumidor.modalSelectStore = true;
    },
    clearFilterFields(field) {
      switch (field) {
        case "status":
          this.$loja_consumidor.filter.status = "";
          break;
        case "tipo_pessoa":
          this.$loja_consumidor.filter.tipoPessoa = "";
          break;
        case "estado":
          this.$loja_consumidor.filter.estado = "";
          break;
        case "cidade":
          this.$loja_consumidor.filter.cidade = "";
          break;
        case "sequenciador":
          this.$loja_consumidor.filter.sequenciador = "";
          break;
        default:
          break;
      }
    },
    async openUser(email) {
      const { access_token, info } = await this.$loja_consumidor.getToken(
        email
      );

      if (access_token) {
        window.open(
          `${
            process.env.VUE_APP_ECOMMERCE_URL
          }?user_token=${access_token}&info=${JSON.stringify(info)}`
        );
      }
    },
  },
  mounted() {
    if (this.storeSequencial) {
      this.$loja_consumidor.filtroConsumidores();
    }
    if (this.$axios.getLocal("loja_cons")?.data) {
      let nomeLoja = this.$axios.getLocal("loja_cons").data;
      this.$loja_consumidor.loja_cons = nomeLoja;
    }
    if (!this.isAdmin) {
      this.fetchEvents({
        producerId: this.storeSequencial,
        filtro: [],
      });
    }
    this.$config.getEstados("9e1bf96ca2754ee6596f26fd6e6b5cc2");
    this.setEvents([]);
  },
  destroyed() {
    this.$loja_consumidor.loja_selecionada = "";
    this.$loja_consumidor.loja_cons = "";
    this.$loja_consumidor.consumidores = [];
    this.$loja_consumidor.limpaFiltros();
    this.setEvents([]);
  },
};
</script>

<style scoped>
.table-actions {
  height: 67px !important;
}

.pessoas-consumidor-container09 {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  overflow-x: auto;
  align-items: center;
  border-radius: 1.25rem;
  flex-direction: column;
  justify-content: flex-start;
  background-color: #fff;
}

.pessoas-consumidor-button08 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  align-items: center;
  border-width: 0px;
  margin-right: 0.625rem;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}

.pessoas-consumidor-button09 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  align-items: center;
  border-width: 0px;
  margin-right: 0.625rem;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}

.pessoas-consumidor-icon {
  fill: var(--dl-color-gray-white);
  width: 24px;
  height: 24px;
}
.consumidor-tipo-pacote {
  width: auto;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  /* padding: 0.125rem 1.5625rem; */
  /* background-color: #c9c9c9; */
  border-radius: 0.9375rem;
}
</style>
